/**
 * A status badge: working, check, failing, not set up.
 *
 * A dot as well as a colour. Red and green differ by very little in lightness
 * for the most common colour blindness, and a status has to survive that.
 */
import styles from "./Badge.module.css";

export function Badge({ tone = "idle", children }) {
  return (
    <span className={styles.badge} data-tone={tone}>
      <span className={styles.dot} aria-hidden="true" />
      {children}
    </span>
  );
}
